import React from 'react';
import { Box, Paper, Typography, Link } from '@mui/material';
import { INK } from '../../utils/commercialColors';

// Plain HTML table, matching MainBoard.jsx's convention for tabular data
// (raw <table>, not MUI's Table component). Clicking a zone applies the
// dashboard's zone filter (in place of a separate /zone/:zone detail
// route from the product spec - the filtered dashboard already shows
// everything that route would, without a second page to maintain).
export default function ZonePerformance({ zones, onZoneClick }) {
  if (!zones) return null;

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Performance par zone
      </Typography>
      <Box sx={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: `1px solid ${INK.gridline}` }}>
              {['Zone', 'Prospects', 'Essais', 'Payants', 'Conversion', 'MRR', 'Churn'].map((h) => (
                <th key={h} style={{ padding: '8px 12px', color: INK.muted, fontWeight: 500 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {zones.map((z) => (
              <tr key={z.zone} style={{ borderBottom: `1px solid ${INK.gridline}` }}>
                <td style={{ padding: '8px 12px', fontWeight: 600 }}>
                  {onZoneClick ? (
                    <Link component="button" onClick={() => onZoneClick(z.zone)} sx={{ color: INK.primary, fontWeight: 600 }}>
                      {z.zone}
                    </Link>
                  ) : (
                    <Box component="span" sx={{ color: INK.primary }}>{z.zone}</Box>
                  )}
                </td>
                <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{z.prospects}</td>
                <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{z.essais}</td>
                <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{z.payants}</td>
                <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{z.conversion_pct}%</td>
                <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{Number(z.mrr).toLocaleString('fr-FR')} €</td>
                <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums', color: z.churn_pct > 5 ? '#d03b3b' : INK.secondary }}>
                  {z.churn_pct}%
                </td>
              </tr>
            ))}
            {zones.length === 0 && (
              <tr><td colSpan={7} style={{ padding: 16, textAlign: 'center', color: INK.muted }}>Aucune donnée</td></tr>
            )}
          </tbody>
        </table>
      </Box>
    </Paper>
  );
}
